// deepanshu_code

import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../../../assets/AdminCss/admin_users.css";
import AdminSidebar from "./AdminSidebar";
import AdminHeader from "./AdminHeader";
import AdminModal from "./AdminModal";

import { useCallback } from "react";
import toast from "react-hot-toast";
import { AuthContext } from "../../../context/Authcontext";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import api from "../../../utils/api";
export const base_url = process.env.REACT_APP_API_URL;

const Admin = () => {
  const navigate = useNavigate();
  const [activeList, setActiveList] = useState(0);
  const [isSidebarOpen, setIsSidebarOpen] = useState(
    !(window.innerWidth < 768)
  );
  const [modal, setModal] = useState({ action: null, id: null });
  const [users, setUsers] = useState([]);
  const [error, setError] = useState();
  const [code, setCode] = useState();
  const [loading, setLoading] = useState(false);
  const [permit, setPermit] = useState([]);
  const { getRoles } = useContext(AuthContext);
  const [hist, setHist] = useState({});
  const [originalUsers, setOriginalUsers] = useState(); // Store original data
  const [searchText, setSearchText] = useState("");
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [page, setPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const limit = 100000000; // items per page

  // Toggle sidebar visibility
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const handleModal = (action, id) => {
    // console.log('dta-id',id, 'action', action);
    setModal({ action: action, id: id });
  };

  const fetchUsers = useCallback(async (pageNumber = 1) => {
    try {
      // console.log(pageNumber, limit);
      const auth = localStorage.getItem("admin");
      const response = await api.post(
        "/api/webapi/admin/listMember",
        {
          typeid: "1",
          pageno: pageNumber,
          limit: limit,
          search: "",
          language: "vi",
          role: "admin",
        },
        {
          withCredentials: true, // ✅ Send cookies with the request
          headers: {
            "Content-Type": "application/json",
            Authorization: `${auth}`,
          },
        }
      );
      // console.log('resp',response);

      if (!response?.data.success) console.log("unable to fetch data");
      const data = response.data;

      console.log("Data is ---------------------" , data.datas)
      // const money = data?.datas[0];
      // console.log('dta',money);
      // setMoney(money.money);
      setUsers(data.datas);
      setOriginalUsers(data.datas);
      setTotalCount(data.totalCount);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);
  // console.log('cod',code);

  const fetchHist = useCallback(async (req, res) => {
    const role = localStorage.getItem("role");
    const auth = localStorage.getItem("auth");
    // console.log('roleee',role);

    const respon = await api.post(
      "/api/webapi/admin/chipHistory",
      { role },
      {
        headers: {
          "content-type": "application/json",
          Authorization: `${auth}`,
        },
      }
    );

    // console.log('respp0',respon);
    const data = respon?.data.result;
    // console.log(data);
    if (respon?.data.success) {
      setHist(data[0]);
    }
  }, []);

  const fetchRoles = useCallback(async () => {
    const auth = localStorage.getItem("admin");
    const role = localStorage.getItem("role");

    try {
      const roles = await getRoles(auth, role);
      let allPermit = [];

      const vall = Object.values(roles[0]);

      const arr = Object.values(vall[0]);

      arr.map((role) => {
        const permis = Object.values(role);

        permis.map((per) => {
          const k = Object.values(per);

          k.map((real) => {
            allPermit.push(real);
          });
        });
      });
      setPermit(allPermit);
    } catch (error) {
      console.log("ert", error);
    }
  }, []);

  const MySwal = withReactContent(Swal);

  const resetUserButton = async (userId) => {
    const result = await MySwal.fire({
      title: "Are you sure?",
      text: "This will reset the user’s password to default (123456).",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, reset it!",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
    });

    if (result.isConfirmed) {
      try {
        const response = await api.post(
          "/api/admin/resetUserButton",
          {
            userId: userId,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (response.data.success) {
          toast.success(response.data.message);
          fetchUsers(page);
        }
      } catch (error) {
        console.error("Error resetting user password:", error);
        toast.error("Something went wrong");
      }
    }
  };

  useEffect(() => {
    fetchRoles();
    fetchHist();
  }, []);

  useEffect(() => {
    fetchUsers(page);
  }, [fetchUsers, page]);

  // console.log('oermit',permit);

  const handleChange = (e) => {
    const searchEle = e.target.value.toLowerCase(); // Convert input to lowercase for case-insensitive search
    setSearchText(searchEle);

    if (searchEle === "") {
      setUsers(originalUsers); // Reset to full data when input is cleared
      return;
    }

    const filteredData = originalUsers?.filter(
      (item) =>
        item.invite.toLowerCase().includes(searchEle) ||
        item.username.toLowerCase().includes(searchEle) // Case-insensitive search
    );

    // console.log("Filtered Data:", filteredData);
    setUsers(filteredData);
  };

  const totalPages = Math.ceil(totalCount / limit);

  const handleNext = () => {
    if (page < totalPages) setPage((prev) => prev + 1);
  };

  const handlePrev = () => {
    if (page > 1) setPage((prev) => prev - 1);
  };
  function formateT(params) {
    let result = params < 10 ? "0" + params : params;
    return result;
  }
  function timerJoin(params = "", addHours = 0) {
    let date = "";
    if (params) {
      date = new Date(Number(params));
    } else {
      date = new Date();
    }

    date.setHours(date.getHours() + addHours);

    let years = formateT(date.getFullYear());
    let months = formateT(date.getMonth() + 1);
    let days = formateT(date.getDate());

    let hours = date.getHours() % 12;
    hours = hours === 0 ? 12 : hours;
    let ampm = date.getHours() < 12 ? "AM" : "PM";

    let minutes = formateT(date.getMinutes());
    let seconds = formateT(date.getSeconds());

    return (
      years +
      "-" +
      months +
      "-" +
      days +
      " " +
      hours +
      ":" +
      minutes +
      ":" +
      seconds +
      " " +
      ampm
    );
  }

  // const toggleLockFancyBetting = (event) => {
  //   // Implement toggle logic here
  //   console.log('Toggling fancy betting:', event.target?.id);
  // };

  // const toggleLockBetting = (event) => {
  //   // Implement toggle logic here
  //   console.log('Toggling betting:', event.target?.id);
  // };

  
  const toggleLockUser = async (currentStatus, userId) => {
    const newStatus = currentStatus === 1 ? 2 : 1;
    // console.log("Toggling user", userId, "from status", currentStatus, "to", newStatus);

    try {
      const response = await api.post(
        "/api/admin/lockUser",
        { status: newStatus, userId },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.success) {
        // console.log("User status updated successfully");
        toast.success("User status updated successfully");
        // Optional: refresh user data here
      } else {
        console.warn("User status update failed");
      }
    } catch (error) {
      console.error("Error updating user status:", error);
    }
  };

  const toggleLockBet = async (newStatus, userId) => {
    // console.log(userId, newStatus);
    try {
      const response = await api.post(
        "/api/admin/lockBet",
        { status: newStatus, userId },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.success) {
        toast.success("User bet lock updated successfully");
      } else {
        console.warn("User bet lock update failed");
      }
    } catch (error) {
      console.error("Error updating user fancy:", error);
    }
  };



  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);

      // On desktop, sidebar should always be "open"
      if (!mobile) {
        setIsSidebarOpen(true);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (loading) return <p>Loading users...</p>;
  if (error) return <p>Error: {error}</p>;

  return (
    <>
      <div className="wrapper">
        {/* Main Sidebar */}
        <AdminSidebar
          isSidebarOpen={isSidebarOpen}
          toggleSidebar={toggleSidebar}
          isMobile={isMobile}
        />

        {/* Header - Pass mobile info */}
        <AdminHeader
          toggleSidebar={toggleSidebar}
          isSidebarOpen={isSidebarOpen}
          isMobile={isMobile}
        />

        {/* Content Wrapper - Use conditional class and margin */}
        <div
          className={`content-wrapper d-flex flex-column ${
            !isMobile && isSidebarOpen ? "" : "open-content-wrapper"
          }`}
          style={{
            marginLeft: !isMobile && isSidebarOpen ? "" : "0",
            transition: "margin-left 0.3s ease",
          }}
        >
          <div className="side-body padding-top">
            <div className="container-fluid">
              <ul className="nav nav-tabs mobile_responsive user-nav">
                <li
                  className={`${
                    activeList === 0 ? "active1" : ""
                  } changecolor cursor-pointer`}
                  onClick={() => setActiveList(0)}
                >
                  <a
                    href="/admin/users"
                    className="active"
                    style={{ pointerEvents: "none" }}
                  >
                    Admin
                  </a>
                </li>
              </ul>
              <div className="d-flex flex-wrap justify-content-between me-3">
                <h1 className="page-title">
                  <i className="sidebar-mini-person" /> Admin
                </h1>
                <div className="pull-right topright_buttons d-flex gap-2">
                  <Link
                    href="##"
                    className={`btn btn-success getsportsetting red_btn ${
                      permit.includes("Add Admin") ? "d-block" : "d-none"
                    }`}
                    onClick={(e) => {
                      e.preventDefault(); // ✅ Prevents reload
                      handleModal("add-admin", null); // ✅ Triggers modal
                    }}
                  >
                    <i className="fa fa-plus" />
                    Add Admin
                  </Link>

                  {/* <Link href="##" className="btn btn-success addAllTypeUsers red_btn" onClick={(e) => {
                    e.preventDefault();  // ✅ Prevents reload
                    handleModal('add', null);  // ✅ Triggers modal
                  }}><i className="fa fa-plus" />
                Add</Link> */}
                  <Link
                    title="A/c Chips In/Out"
                    href="##"
                    className={`btn btn-sm btn-info color-1 ${
                      permit.includes("A/C chips In/Out") ? "d-block" : "d-none"
                    }`}
                    onClick={(e) => {
                      e.preventDefault(); // ✅ Prevents reload
                      handleModal("chips-in-out", null); // ✅ Triggers modal
                    }}
                  >
                    A/c Chips In/Out [Super Admin]
                  </Link>
                  {/* <Link href="#" className="btn btn-danger getbalancesheet"><i className="fa fa-file" /> Export</Link> */}
                </div>
              </div>
            </div>
            <div id="sidebar-mini-notifications" />
            <div className="page-content browse container-fluid">
              <div className="alerts"></div>
              <div className="row me-0">
                <div className="col-md-12 oneonofftab">
                  <div className="panel panel-bordered sportsNew">
                    {/*<div className="panel-body">
                  <table className="table table-hover dataTableuser table-responsive user-outer">
                  <thead>
                      <tr>
                        <th>Available Balance</th>
                        <th>Amount</th>
                        <th>Debit/Credit</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{money}</td>
                        <td>{hist?.amount}</td>
                        <td>{hist?.type}</td>
                      </tr>
                    </tbody>
                  </table>
               
                </div>*/}

                    <div className="relative p-2 max-w-sm mx-auto">
                      <input
                        type="text"
                        placeholder="🔍 Search by username or invite..."
                        onChange={(e) => handleChange(e)}
                        className="w-100 px-4 py-2 pl-10 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-150 ease-in-out"
                      />
                    </div>

                    <div className="dataTable mt-5 table-responsive">
                      <table
                        id="dataTable"
                        className="table table-hover dataTableuser table-responsive-sm user-outer"
                      >
                        <thead className="text-nowrap">
                          <tr>
                            <th className="table-bg">
                              <Link href="#">ID</Link>
                            </th>
                            <th className="table-bg">
                              <Link href="#">Name</Link>
                            </th>
                            <th className="table-bg">
                              <Link href="#">User Name</Link>
                            </th>
                            {/* <th className="table-bg">
                          <Link href="#">Password</Link>
                        </th> */}
                            <th className="table-bg">
                              <Link href="#">Role</Link>
                            </th>
                            <th className="table-bg">
                              <Link href="#">Main Balance</Link>
                            </th>
                            {/* <th className="table-bg">
                              <Link href="#">Exp</Link>
                            </th> */}
                            <th className="table-bg">
                              <Link href="#">Bonus</Link>
                            </th>
                            <th className="table-bg">
                              <Link href="#">Commission%</Link>
                            </th>
                            {/* <th className="table-bg">
                          <Link href="#">Given Commission%</Link>
                        </th> */}
                            {/* <th className="table-bg">
                              <Link href="#"> Settlment Amount</Link>
                            </th> */}
                            {/* <th className="table-bg">
                          <Link href="#">Fancy Locked</Link>
                        </th> */}
                        <th className="table-bg">
                          <Link href="#">Betting Locked</Link>
                        </th>
                            <th className="table-bg">
                              <Link href="#">User Locked</Link>
                            </th>
                            {/* <th className="table-bg">
                          <Link href="#">Closed Account</Link>
                        </th> */}
                            <th className="table-bg">
                              <Link href="#">Created by</Link>
                            </th>
                            <th className="table-bg">
                              <Link href="#">self code </Link>
                            </th>
                            <th className="table-bg">
                              <Link href="#">Created</Link>
                            </th>
                            <th className="table-bg">
                              <Link href="#">Profit Loss</Link>
                            </th>
                            <th className="table-bg">
                              <Link href="#">Created At</Link>
                            </th>
                            <th className="table-bg">
                              <Link href="#">Options</Link>
                            </th>
                            <th
                              className={`table-bg ${
                                permit.includes("View More/Edit")
                                  ? ""
                                  : "d-none"
                              }`}
                            >
                              Actions
                            </th>
                          </tr>
                        </thead>
                        <tbody className="admindata">
                          {users?.map(
                            (data) =>
                              data.role === "admin" && (
                                <tr key={data.id}>
                                  <td className="pdl0pdr0 border">
                                    <span>{data.id}</span>
                                  </td>
                                  <td
                                    className="pdl0pdr0 border"
                                    onClick={() =>
                                      navigate(
                                        `/admin/getChildUsers/${data.code}`
                                      )
                                    }
                                  >
                                    <Link
                                      href="#"
                                      title="View Child User"
                                      style={{ color: "#000" }}
                                    >
                                      {data.username}
                                    </Link>
                                  </td>
                                  <td
                                    className="pdl0pdr0 border"
                                    onClick={() =>
                                      navigate(
                                        `/admin/getChildUsers/${data.code}`
                                      )
                                    }
                                  >
                                    <span>{data.phone}</span>
                                  </td>
                                  {/* <td className="pdl0pdr0 border">
                                <span>{data.plain_password}</span>
                              </td> */}
                                  <td className="pdl0pdr0 border">
                                    <span>{data.role}</span>
                                  </td>
                                  <td className="pdl0pdr0 border">
                                    {data.money}
                                  </td>
                                  {/* <td className="pdl0pdr0 border">
                                    {data.downlineAmount}
                                  </td> */}
                                  <td className="pdl0pdr0 border">
                                    <span className="green">
                                      {data.bonus_money}
                                    </span>
                                  </td>
                                  <td className="pdl0pdr0 border">
                                    <span className="green">
                                      {data.commission}
                                    </span>
                                  </td>
                                  {/* <td className="pdl0pdr0">
                                <span className="green">{data.givecommission}</span>
                              </td> */}
                                  {/* <td className="pdl0pdr0 border">
                                    <span className="green">0.00</span>
                                  </td> */}

                                  <td className="pdl0pdr0 border text-center px-3">
                            <div className="form-row customtoggle">
                              <div
                                className="form-group"
                                style={{ position: "relative" }}
                              >
                                <label
                                  htmlFor="lockuser"
                                  title="Self Lock"
                                >
                                  {" "}
                                  Bet Lock
                                </label>
                                <div className="toggle_bx">
                                  <label className="switch">
                                    <input
                                      type="checkbox"
                                      name="lock_betting"
                                      id={data.id_user}
                                      value="1"
                                      defaultChecked={
                                        data.betlock === 1
                                      }
                                      onChange={(e) => {
                                        const isChecked =
                                          e.target.checked;
                                        const newStatus = isChecked
                                          ? 1
                                          : 0;
                                        toggleLockBet(
                                          newStatus,
                                          data.id_user
                                        );
                                      }}
                                    />
                                    <div className="slider round extratoggle" />
                                  </label>
                                </div>
                              </div>
                            </div>
                          </td>
                          <td className="pdl0pdr0 border">
                            <div className="form-row customtoggle">
                              <div
                                className="form-group"
                                style={{ position: "relative" }}
                              >
                                <label
                                  htmlFor="lockuser"
                                  title="Self Lock"
                                >
                                  {" "}
                                  Self Lock
                                </label>
                                <div className="toggle_bx">
                                  <label className="switch">
                                    <input
                                      type="checkbox"
                                      name="close_account"
                                      id={data.id_user}
                                      value="1"
                                      defaultChecked={data.status === 2}
                                      onChange={() =>
                                        toggleLockUser(
                                          data.status,
                                          data.id_user
                                        )
                                      }
                                    />
                                    <div className="slider round extratoggle" />
                                  </label>
                                </div>
                              </div>
                            </div>
                          </td>
                                  <td className="pdl0pdr0 border">
                                    {data.createdBy}
                                  </td>
                                  <td className="pdl0pdr0 border">
                                    {data.code}
                                  </td>
                                  <td className="pdl0pdr0 border">
                                    {data.create_status === 1
                                      ? "Sign Up"
                                      : "Admin Panel"}
                                  </td>
                                  <td
                                    className={`pdl0pdr0 border ${
                                      parseFloat(data.totalProfit) -
                                        parseFloat(data.totalProfit) >
                                      0
                                        ? "text-green"
                                        : "text-red"
                                    }`}
                                  >
                                    {(
                                      parseFloat(data.totalProfit) -
                                      parseFloat(data.totalProfit)
                                    ).toFixed(2)}
                                  </td>
                                  <td className="pdl0pdr0 border">
                                    {timerJoin(data.time)}
                                  </td>
                                  <td className="pdl0pdr0 border">
                                    <div className="d-flex gap-1">
                                      <Link
                                        to={`/admin/userSetting/${data.phone}/${data.code}`}
                                        title="Setting"
                                        className="optionsBtn"
                                      >
                                        S
                                      </Link>
                                      <Link
                                        to={`/admin/userBetHistory/${data.phone}`}
                                        title="Bet History"
                                        className="optionsBtn"
                                      >
                                        BH
                                      </Link>
                                      <Link
                                        to={`/admin/userSportsSetting/${data.phone}`}
                                        title="Sports Setting"
                                        className="optionsBtn"
                                      >
                                        SS
                                      </Link>
                                      <Link
                                        to={`/admin/userStatement/${data.id}`}
                                        title="Account Statement"
                                        className="optionsBtn"
                                      >
                                        AS
                                      </Link>
                                      <Link
                                        onClick={() =>
                                          resetUserButton(data.phone)
                                        }
                                        title="Reset Password Button"
                                        className="optionsBtn"
                                      >
                                        P
                                      </Link>
                                    </div>
                                  </td>
                                  <td
                                    className={`no-sort no-click ${
                                      permit.includes("View More/Edit")
                                        ? ""
                                        : "d-none"
                                    } `}
                                    id="bread-actions"
                                  >
                                    <span className="dropdown user-more-btn">
                                      <Link
                                        href="#"
                                        className="btn btn-xs btn-success"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          handleModal("user-show", data.id);
                                        }}
                                      >
                                        View More <span className="caret" />
                                      </Link>
                                    </span>
                                  </td>
                                </tr>
                              )
                          )}
                        </tbody>
                      </table>
                      
                    </div>
                    <div className="pagination-controls mt-3 d-flex justify-content-between align-items-center">
                        <button
                          className="btn-info border-0 p-2 rounded"
                          onClick={handlePrev}
                          disabled={page === 1}
                        >
                          Previous
                        </button>
                        <span>
                          Page {page} of {totalPages || 1}
                        </span>
                        <button
                          className="btn-info border-0 p-2 rounded"
                          onClick={handleNext}
                          disabled={page === totalPages}
                        >
                          Next
                        </button>
                      </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
        <AdminModal
          modal={modal}
          setModal={setModal}
          data={users}
          code={code}
        />
        {
          <div
            id="overlayId"
            className={`overlay ${modal?.action ? "d-block" : "d-none"}`}
          ></div>
        }
      </div>
    </>
  );
};
export default Admin;